<template>
  <div
    class="draggable resizable"
    style="position: fixed; top: 300px; left: 350px;"
  >
    <div
      class="mx-auto window win-card"
      style="width: 250px;"
      v-if="open"
      @click="$emit('toFront')"
    >
      <WindowBar
        title="Celery Man"
        @close="$emit('close')"
        @maximize="maximized=true"
        @minimize="maximized=false"
      />
      <img
        style="display:block; margin: 20px auto;"
        src="oli-gif-2.gif"
        width="225"
        v-show="maximized"
      />
    </div>
  </div>
</template>

<script>
import WindowBar from './WindowBar.vue'

export default {
  name: "ProfileNE",
  data() {
    return {
      open: true,
      maximized: true,
    };
  },
  components: {
    WindowBar,
  },
};
</script>

<style scoped src="98.css">
.window {
  touch-action: none;
}
</style>
